import type { PropsWithChildren } from "react";
import {
  CurrentUserContext,
  type CurrentUser,
} from "./CurrentUserContext";

export function CurrentUserProvider({
  children,
  user,
}: PropsWithChildren<{ user: CurrentUser }>) {
  const logout = async () => {
    try {
      await fetch("/api/auth/logout", { method: "POST" });
    } finally {
      window.location.assign("/login");
    }
  };

  return (
    <CurrentUserContext.Provider value={{ ...user, logout }}>
      {children}
    </CurrentUserContext.Provider>
  );
}
